import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../../../@types/filter";
import { Paginated } from "../../../../../../../@types/paginated";
import { apisiseci } from "../../../../../../api";
import { useDefaultSearchParams } from "../../../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../@types/attendance-local-department-guiche";
import { AttendanceLocalDepartmentGuicheServiceComplement } from "../../../../../../../@types/attendance-local-department-guiche-service";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  guiche?: AttendanceLocalDepartmentGuiche["id"]
};

export function useAttendanceLocalDepartmentGuicheServiceComplementList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalDepartmentGuicheServiceComplement>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['attendance-local', 'department', 'guiche', 'service-complement', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentGuicheServiceComplement>>(
        "/cms/guiche_servico_complementar/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
